import React, { useContext } from "react"
import { defineMessage, useIntl } from "react-intl"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { RadioGroupStep } from "../variants/RadioGroupStep"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { CarrotCardCostSharePreAuthContext } from "#/components/carrot-card-cost-share/state/CarrotCardCostSharePreAuthContext"

const consideredMedicallyNecessaryOptions = [
  { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
  { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
]

export function ConsideredMedicallyNecessaryPreservationStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { isMedicallyNecessary, isInfertilityDx },
    serverState: { hasElectivePreservationCoverage, isMedicallyNecessaryPreservationCovered }
  } = useContext(CarrotCardCostSharePreAuthContext)
  const formattedOptions = useConvertTranslatedLabel(consideredMedicallyNecessaryOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({
      type: "UPDATE_FIELD",
      field: "isMedicallyNecessary",
      value: formValues.isMedicallyNecessary
    })

    if (hasElectivePreservationCoverage && isMedicallyNecessaryPreservationCovered) {
      send("ELIGIBLE")
      return
    }

    if (
      !hasElectivePreservationCoverage &&
      isMedicallyNecessaryPreservationCovered &&
      (formValues.isMedicallyNecessary === "YES" || isInfertilityDx === "YES")
    ) {
      send("ELIGIBLE")
      return
    }

    if (
      hasElectivePreservationCoverage &&
      !isMedicallyNecessaryPreservationCovered &&
      formValues.isMedicallyNecessary === "NO" &&
      isInfertilityDx === "NO"
    ) {
      send("ELIGIBLE")
      return
    }

    send("INELIGIBLE")
  }

  return (
    <RadioGroupStep
      title={intl.formatMessage({
        defaultMessage: "Is the care considered medically necessary by an eligible fertility provider?"
      })}
      description={intl.formatMessage({
        defaultMessage:
          "If you’re not sure, ask your provider. This helps us determine if the care may be a qualified medical expense. "
      })}
      name="isMedicallyNecessary"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={isMedicallyNecessary}
    />
  )
}
